import React, { useEffect } from 'react';
import toast from 'react-hot-toast';

import { useCurrentUser, usePaymentInfo } from '../../hooks';
import useScrollToAnchor from '../../hooks/useScrollToAnchor';
import { root_path } from '../../routes';
import { Spinner } from '../BaseUI';
import MetaTags from '../shared/MetaTags';
import UpdatePaymentDetails from './UpdatePaymentInfo';

const UpdatePayment = () => {
  const { currentUser } = useCurrentUser();
  const { data, isLoading } = usePaymentInfo();

  useEffect(() => {
    if (
      Object.prototype.hasOwnProperty.call(currentUser, 'can_update_payment') &&
      currentUser.can_update_payment === false
    ) {
      toast.error(
        'You do not have an active subscription. For more information, please contact support@theinformation.com.'
      );
      window.location.href = root_path;
    }
  }, [currentUser]);
  useScrollToAnchor(isLoading);
  const description = 'Update your payment method';

  return (
    <>
      <MetaTags
        title="Update Payment Method"
        description={description}
        ogSiteName="The Information"
      />
      {isLoading ? <Spinner /> : <UpdatePaymentDetails {...data} />}
    </>
  );
};

export default UpdatePayment;
